module.exports = __webpack_public_path__ + "img/bg-image-21.80eb2b2a.jpg";